function supportFeatures () {
  return !!(
    typeof Array.of === 'function'
    && typeof Array.prototype.find === 'function'
    && typeof Array.prototype.flatMap === 'function'
    && typeof Array.prototype.values === 'function'
    && typeof Array.prototype.findIndex === 'function'
    && typeof String.prototype.endsWith === 'function'
    && typeof String.prototype.padStart === 'function'
    && typeof String.prototype.repeat === 'function'
    && typeof Object.entries === 'function'
    && typeof window.Promise === 'function'
  )
}

async function init () {
  if (!window.IntersectionObserver) {
    console.log('loading IntersectionObserver polyfill...')
    await import('intersection-observer')
  }
  if (!window.fetch) {
    console.log('loading fetch polyfill...')
    await import('whatwg-fetch')
  }
  if (!supportFeatures()) {
    console.log('loading stable polyfills...')
    // @ts-ignore
    await import('core-js/stable')
  }
  require('./registerServiceWorker')
  require('./initApp')
}

init()